import { gql } from "@apollo/client";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "moment-timezone";
import { partialMatch } from "../../utils/elasticSearch.js";
import { nameOf } from "../../utils/object.js";
import "react-intl";
class AgentProfileRequestBuilder extends GqlRequestBuilder {
  validateFilters(_filter) {
    return;
  }
  buildQuery = (fields) => gql`
        query GetAgentProfiles($filter: AgentProfileFilter) {
            getAgentProfiles(filter: $filter) {
                uid @include(if: ${this.hasField(fields, "uid")})
                username @include(if: ${this.hasField(fields, "username")})
                referral @include(if: ${this.hasAnyField(fields, this.getReferralQueryItems())}) {
                    inviting_user_id @include(if: ${this.hasField(fields, "referral.inviting_user_id")})
                }
            }
        }
    `;
  buildFilter(filter) {
    return {
      filter: {
        text: this.getGQLTextFilter(
          Object.keys(this.filterFieldsMapper).map(
            (key) => this.toGQLTextFilter(this.filterFieldsMapper[key], filter[key], this.transformTextMapper[key])
          )
        ),
        referrer_agent_id: this.toGQLStringFilter(filter, "referrer_agent_id"),
        is_master_agent: this.toGQLBooleanFilter(filter, "is_master_agent")
      }
    };
  }
  getGqlPageArgs(filter) {
    return filter ? this.buildFilter(filter) : {};
  }
  filterFieldsMapper = {
    uid: [nameOf("uid")],
    username: [nameOf("username")],
    uidPartial: [nameOf("uid")]
  };
  transformTextMapper = {
    username: partialMatch,
    uidPartial: partialMatch
  };
  getReferralQueryItems() {
    return ["referral.inviting_user_id"];
  }
}
export {
  AgentProfileRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
